<script setup>
import { computed } from 'vue';

const props = defineProps({
  reactions: {
    type: Array,
    default: () => [],
  },
});

/**
 * Группирует реакции по emoji
 * @returns {Object} Объект где ключ - emoji, значение - массив пользователей
 */
const groupedReactions = computed(() => {
  if (!props.reactions || !Array.isArray(props.reactions)) {
    return {};
  }

  const grouped = {};
  props.reactions.forEach(reaction => {
    const emoji = reaction.emoji || reaction.reaction?.emoji;
    if (!emoji) return;

    if (!grouped[emoji]) {
      grouped[emoji] = [];
    }
    grouped[emoji].push({
      userId: reaction.user_id,
      userName: reaction.user_name,
      timestamp: reaction.timestamp,
    });
  });
  return grouped;
});

/**
 * Форматирует список пользователей для tooltip
 */
const formatUserList = users => {
  if (users.length === 1) {
    return users[0].userName;
  }
  if (users.length === 2) {
    return `${users[0].userName} и ${users[1].userName}`;
  }
  return `${users[0].userName} и еще ${users.length - 1}`;
};
</script>

<template>
  <div
    v-if="Object.keys(groupedReactions).length > 0"
    class="flex flex-wrap gap-1 mt-1.5"
  >
    <div
      v-for="(users, emoji) in groupedReactions"
      :key="emoji"
      v-tooltip.top="formatUserList(users)"
      class="inline-flex items-center gap-1 px-2 py-0.5 rounded-full bg-n-alpha-2 hover:bg-n-alpha-3 transition-colors cursor-default text-xs"
    >
      <span class="text-base leading-none">{{ emoji }}</span>
      <span v-if="users.length > 1" class="text-n-slate-11 font-medium">
        {{ users.length }}
      </span>
    </div>
  </div>
</template>
